import { render, staticRenderFns } from "./liked-mixes-card.vue?vue&type=template&id=c8e5d064&scoped=true"
import script from "./liked-mixes-card.vue?vue&type=script&setup=true&lang=js"
export * from "./liked-mixes-card.vue?vue&type=script&setup=true&lang=js"
import style0 from "./liked-mixes-card.vue?vue&type=style&index=0&id=c8e5d064&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e5d064",
  null
  
)

export default component.exports